import { FC } from "react";
import { PickerItem } from "./PickerItem";
import "./Picker.css";

interface Props {
  items: string[];
  label: string;
  currentPickedItem: string;
  onItemClick: (item: string) => void;
}

export const Picker: FC<Props> = ({
  items,
  label,
  currentPickedItem,
  onItemClick,
}) => {
  return (
    <div className="picker">
      <h2 className="picker-header">{label}</h2>
      <div className="picker-wrapper">
        {items.map((item) => {
          const isActive = currentPickedItem === item;

          return (
            <PickerItem
              key={item}
              item={item}
              isPicked={isActive}
              onItemClick={onItemClick}
            />
          );
        })}
      </div>
    </div>
  );
};
